import React, { Fragment, useState, useEffect } from "react";

import { useFormik } from 'formik';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import { ApiHooks } from "../../../services/api";
import { formatShortPhoneNumber, capitalizeLocal,GetStartedSubmitted } from "../../../helpers/functions";
import FloatIcon from "../FloatIcon/FloatIcon";

export default function FormFields({zip,storeId, setLoading, setSubmissionComplete}) {
    
    const { verifyZip, saveShortForm } = ApiHooks();
    const [stateCA, SetStateCA] = useState(""); 
    const [ zipCode, SetZipCode] = useState(zip);

    const formik = useFormik({
        initialValues: {
          firstName: '',
          lastName: '',
          email: '',
          mobile:'',
          zipCode: zipCode,
          city: '',
          address: '',
          apt: '',
          ssn: '',
          privacy: false,
          recaptcha: '', 
        },
        validationSchema: Yup.object({
          firstName:    Yup.string()
                        .required('First name is required')
                        .min(2, 'First name is too Short!')
                        .max(25, ({max}) => `First name must be between 2 and 25 characters. You entered ${max} characters`),
          lastName:     Yup.string().
                        required('Last name is required')
                        .min(2, 'Last name is too Short!')
                        .max(25, ({max})=> `Last name must be between 2 and 25 characters. You entered ${max} characters`),
          email:        Yup.string()
                        .email('Invalid email address')
                        .required('Email is required')
                        .min(6, 'Email is too Short!')
                        .max(60, 'Email is too Long!'),
          mobile:       Yup.string()
                        .required('Your phone number is required')
                        .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'Phone number must be in the format (XXX) XXX-XXXX'),
          zipCode:      Yup.string()
                        .required('Zip code is required')
                        .min(4, 'Zip code is too Short!')
                        .max(5, 'Zip code is too Long!'),
          city:         Yup.string()
                        .required('City is required')
                        .min(3, 'City is too Short!')
                        .max(60, 'City is too Long!'),
          address:      Yup.string()
                        .required('Your address is required')
                        .min(4, 'Your address is too Short!')
                        .max(80, 'Your address is too Long!'),
          apt:          Yup.string()
                        .min(3, 'Your Apt., Bldg., Suite is too Short!')
                        .max(80, 'Your Apt., Bldg., Suite is too Long!'),
          ssn:          Yup.string()
                        .required('Your SSN is required')
                        .min(4, 'SSN is too Short!')
                        .max(4, ({ max }) => `SSN must be exactly ${max} characters`),
          privacy:      Yup.boolean()
                        .oneOf([true], 'You must agree to the terms and conditions'),
          recaptcha:    Yup.string()
                        .required('reCAPTCHA verification is required'),
        }),
        onSubmit: async (values) => {
              setLoading(true);
            const formData = {
                ...values,
                state: stateCA,
                store: storeId,
              };
              try {
                const data = await saveShortForm(formData);
                GetStartedSubmitted("get-started-online", storeId,values.city, values.zipCode);
                setSubmissionComplete(data.data);
              } catch (error) {
                console.error(error);
              } finally {
                setLoading(false);
              }
        },
      });
    
      const handleCaptchaChange = (value) => {
        formik.setFieldValue('recaptcha', value || '');
        formik.setFieldTouched('recaptcha', true);
      };
      const handleMobileChange = (e) => {
        const input = e.target.value;
        const formattedValue = formatShortPhoneNumber(input);
        formik.setFieldValue('mobile', formattedValue);
      };
      useEffect(() => {
        if (zipCode) {
            SearchZipCode(zipCode);
        }
      }, [zipCode]);

      const SearchZipCode = (zip) => {
        verifyZip(zip)
        .then((data) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data.data, 'text/xml');
            const stateNameLocal = (xmlDoc.getElementsByTagName('State').length > 0) ? xmlDoc.getElementsByTagName('State')[0].textContent: undefined;
            const cityName  = (xmlDoc.getElementsByTagName('City').length > 0) ? xmlDoc.getElementsByTagName('City')[0].textContent :undefined ;
            let city_format = capitalizeLocal(cityName.toLowerCase());
            formik.setFieldValue('city', city_format);
            SetStateCA((stateNameLocal));
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
      }
  return (
    <Fragment>
        <h5 className="modal-title" id="shortFormLabel">Start Your Application Online and Finish it at a Store Near You.</h5>
        <form onSubmit={formik.handleSubmit}>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    className="form-control group-short"
                    placeholder="First Name"
                    aria-label="First Name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.firstName}
                />
                {formik.touched.firstName && formik.errors.firstName && <p style={{ color: 'red' }}>{formik.errors.firstName}</p>}
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    className="form-control group-short"
                    placeholder="Last Name"
                    aria-label="Last Name"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.lastName}
                />
                {formik.touched.lastName && formik.errors.lastName && <p style={{ color: 'red' }}>{formik.errors.lastName}</p>}
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control group-short"
                    placeholder="Email"
                    aria-label="Email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email && <p style={{ color: 'red' }}>{formik.errors.email}</p>}
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="text"
                    id="mobile"
                    name="mobile"
                    className="form-control group-short"
                    placeholder="Phone Number"
                    aria-label="Phone Number"
                    onChange={handleMobileChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.mobile}
                />
                {formik.touched.mobile && formik.errors.mobile && <p style={{ color: 'red' }}>{formik.errors.mobile}</p>}
            </div>
            <div className="form-group short-div">
                <select className="form-control group-short" disabled>
                    <option value="California">California</option>
                </select>
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="text"
                    id="address"
                    name="address"
                    className="form-control group-short"
                    placeholder="Address"
                    aria-label="Address"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.address}
                />
                {formik.touched.address && formik.errors.address && <p style={{ color: 'red' }}>{formik.errors.address}</p>}
            </div>
            <div className="form-group short-div">
                <input
                    type="text"
                    id="apt"
                    name="apt"
                    className="form-control group-short"
                    placeholder="Apt., Bldg., Suite"
                    aria-label="Apt., Bldg., Suite"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.apt}
                />
                {formik.touched.apt && formik.errors.apt && <p style={{ color: 'red' }}>{formik.errors.apt}</p>}
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="text"
                    id="city"
                    name="city"
                    className="form-control group-short"
                    placeholder="City"
                    aria-label="City"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.city}
                />
                {formik.touched.city && formik.errors.city && <p style={{ color: 'red' }}>{formik.errors.city}</p>}
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="text"
                    id="zipCode"
                    name="zipCode"
                    className="form-control group-short"
                    placeholder="Zip Code"
                    aria-label="Zip Code"
                    pattern="\d*"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.zipCode}
                />
                {formik.touched.zipCode && formik.errors.zipCode && <p style={{ color: 'red' }}>{formik.errors.zipCode}</p>}
            </div>
            <div className="form-group short-div">
                <label className="required-label">Required</label>
                <input
                    type="password"
                    id="ssn"
                    name="ssn"
                    className="form-control group-short"
                    placeholder="Last 4 of SSN"
                    aria-label="SSN"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.ssn}
                    autoComplete="false"
                />
                {formik.touched.ssn && formik.errors.ssn && <p style={{ color: 'red' }}>{formik.errors.ssn}</p>}
            </div>
            <div className="form-group short-div">
                <div className="checkbox">
                    <label className="cic_container_local lb-black">By completing submission you agree to California Check Cashing Stores <a href="/communication-preferences/" target="_blank" rel="noopener noreferrer">Communication Preferences</a>, <a href="https://disclosures.ccffamilyofbrands.com/ccf/ca-privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a target="_blank" href="https://disclosures.ccffamilyofbrands.com/ccf/ca-notice-at-collection">California Notice Collection</a>.
                        <input 
                            name="privacy" 
                            type="checkbox"
                            checked={formik.values.privacy}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                        />
                        <span className="checkmark_local"></span>
                    </label>
                </div>
                {formik.touched.privacy && formik.errors.privacy && ( <p style={{ color: 'red' }}>{formik.errors.privacy}</p> )}
            </div>
            <div className="form-group short-div">
                <ReCAPTCHA className="captcha-center" sitekey="6LckUlwpAAAAAJPIfhSb--6iKwZeJ6k4Sddv7idf" onChange={handleCaptchaChange} />
                {formik.touched.recaptcha && formik.errors.recaptcha && (
                    <p style={{ color: 'red' }}>{formik.errors.recaptcha}</p>
                )}
            </div>
            <div className="form-group short-div captcha-center">
                <button className="cic-btn cic-btn-get-started" type="submit">
                    <FloatIcon />
                    Submit
                </button>
            </div>
            
        </form>
    </Fragment>
  )
}
